import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VideoZipRequestArgs } from 'redux/middleware/api/creation-service/types';

import {
  cancelVideoZipRequestPolling,
  currentVideoZipRequestStatusSelector,
  getVideoZipRequest,
  pollForVideoZipRequest,
  zipRequestIdSelector,
} from 'redux/modules/video-zip-request';

import { Dispatch } from 'redux/types';

export default function useVideoZipRequestPolling({
  creationRequestId,
  groupRequestId,
}: VideoZipRequestArgs) {
  const hasInitialized = useRef(false);

  const dispatch = useDispatch<Dispatch>();

  const zipRequestId = useSelector(zipRequestIdSelector);
  const videoZipRequestStatus = useSelector(
    currentVideoZipRequestStatusSelector,
  );

  useEffect(() => {
    if (!creationRequestId && !groupRequestId) {
      dispatch(cancelVideoZipRequestPolling());

      return;
    }

    if (
      !hasInitialized.current &&
      videoZipRequestStatus === undefined &&
      zipRequestId === undefined
    ) {
      dispatch(
        getVideoZipRequest({
          creationRequestId,
          groupRequestId,
        }),
      );

      hasInitialized.current = true;
    }

    if (videoZipRequestStatus === 'processing' || zipRequestId) {
      dispatch(pollForVideoZipRequest({ zipRequestId }));
    }
  }, [
    creationRequestId,
    dispatch,
    groupRequestId,
    videoZipRequestStatus,
    zipRequestId,
  ]);

  useEffect(() => {
    return () => {
      dispatch(cancelVideoZipRequestPolling());
    };
  }, [dispatch]);
}
